import '../styles/pages/page.scss';
import Button from '../components/Button';
import ReactPlayer from 'react-player';
import ReactGA from 'react-ga4';

const Media = () => (
    <div className="page-container">
        <div className="main-container">
            <h1 className="main-title">
                Media
            </h1>
            <div className="video-container" style={{marginBottom: '50px'}}>
                <div className="video-wrapper">
                    <ReactPlayer url="https://www.youtube.com/watch?v=Z5gWOnu7tSA"/>
                </div>
            </div>
            <div className="video-container" style={{marginBottom: '50px'}}>
                <div className="video-wrapper">
                    <ReactPlayer url="https://www.youtube.com/watch?v=erUxbClcXL0"/>
                </div>
            </div>
            <h1 className="main-title">
                Wallpapers and Avatars
            </h1>
            <h1 className="media-title">
                Wallpaper #1
            </h1>
            <div className="wallpaper-wrapper">
                <div className="pair">
                    <img src="./img/downloads/YomawariLitD_Wallpaper_2560x1600_01.png" alt="Wallpaper 1" />
                    <div className="download-list">
                        <a href="./img/downloads/YomawariLitD_Wallpaper_3840x2160_01.png" target="_blank" download="YomawariLitD_Wallpaper_3840x2160_01.png">
                            <Button text={"Large (3840x2160)"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Large - 01`
                            })}}/>
                        </a>
                        <a href="./img/downloads/YomawariLitD_Wallpaper_2560x1600_01.png" download="YomawariLitD_Wallpaper_2560x1600_01.png">
                            <Button text={"Medium (2560x1600)"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Medium - 01`
                            })}}/>
                        </a>
                        <a href="./img/downloads/YomawariLitD_Wallpaper_Phone01.png" download="YomawariLitD_Wallpaper_2560x1600_01.png">
                            <Button text={"Mobile"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Mobile - 01`
                            })}}/>
                        </a>
                    </div>
                </div>
            </div>
            <h1 className="media-title">
                Wallpaper #2
            </h1>
            <div className="wallpaper-wrapper">
                <div className="pair">
                    <img src="./img/downloads/YomawariLitD_Wallpaper_2560x1600_02.png" alt="Wallpaper 2" />
                    <div className="download-list">
                        <a href="./img/downloads/YomawariLitD_Wallpaper_3840x2160_02.png" target="_blank" download="YomawariLitD_Wallpaper_3840x2160_02.png">
                            <Button text={"Large (3840x2160)"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Large - 02`
                            })}}/>
                        </a>
                        <a href="./img/downloads/YomawariLitD_Wallpaper_2560x1600_02.png" download="YomawariLitD_Wallpaper_2560x1600_02.png">
                            <Button text={"Medium (2560x1600)"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Medium - 02`
                            })}}/>
                        </a>
                        <a href="./img/downloads/YomawariLitD_Wallpaper_Phone02.png" download="YomawariLitD_Wallpaper_2560x1600_02.png">
                            <Button text={"Mobile"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Mobile - 02`
                            })}}/>
                        </a>
                    </div>
                </div>
            </div>
            <h1 className="media-title">
                Wallpaper #3
            </h1>
            <div className="wallpaper-wrapper">
                <div className="pair">
                    <img src="./img/downloads/YomawariLitD_Wallpaper_2560x1600_03.png" alt="Wallpaper 3" />
                    <div className="download-list">
                        <a href="./img/downloads/YomawariLitD_Wallpaper_3840x2160_03.png" target="_blank" download="YomawariLitD_Wallpaper_3840x2160_03.png">
                            <Button text={"Large (3840x2160)"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Large - 03`
                            })}}/>
                        </a>
                        <a href="./img/downloads/YomawariLitD_Wallpaper_2560x1600_03.png" download="YomawariLitD_Wallpaper_2560x1600_03.png">
                            <Button text={"Medium (2560x1600)"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Medium - 03`
                            })}}/>
                        </a>
                        <a href="./img/downloads/YomawariLitD_Wallpaper_Phone03.png" download="YomawariLitD_Wallpaper_2560x1600_03.png">
                            <Button text={"Mobile"} color="red" onClick={()=>{
                                ReactGA.event({
                                    category: 'Media Link',
                                    action: 'Download',
                                    label: `Mobile - 03`
                            })}}/>
                        </a>
                    </div>
                </div>
            </div>
            <div className="media-title">
                Avatar Icons
            </div>
            <div className="media-caption">
                Click on the Avatar to download it!
            </div>
            <div className="icon-container">
                <a href="./img/downloads/YomawariLitD_Avatar_Protagonist.png" download="YomawariLitD_Avatar_Protagonist">
                    <img src="./img/downloads/YomawariLitD_Avatar_Protagonist.png" alt="Protagonist" onClick={()=>{
                            ReactGA.event({
                                category: 'Media Link',
                                action: 'Download',
                                label: `Avatar - Protag`
                        })}}/>
                </a>
                <a href="./img/downloads/YomawariLitD_Avatar_BirdSpirit.png" download="YomawariLitD_Avatar_BirdSpirit">
                    <img src="./img/downloads/YomawariLitD_Avatar_BirdSpirit.png" alt="Bird Spirit" onClick={()=>{
                            ReactGA.event({
                                category: 'Media Link',
                                action: 'Download',
                                label: `Avatar - Bird`
                        })}}/>
                </a>
                <a href="./img/downloads/YomawariLitD_Avatar_GirlWithCamera.png" download="YomawariLitD_Avatar_GirlWithCamera.png">
                    <img src="./img/downloads/YomawariLitD_Avatar_GirlWithCamera.png" alt="Girl With Camera" onClick={()=>{
                            ReactGA.event({
                                category: 'Media Link',
                                action: 'Download',
                                label: `Avatar - GirlWithCamera`
                        })}}/>
                </a>
                <a href="./img/downloads/YomawariLitD_Avatar_Mugi.png" download="YomawariLitD_Avatar_Mugi.png">
                    <img src="./img/downloads/YomawariLitD_Avatar_Mugi.png" alt="Mugi" onClick={()=>{
                            ReactGA.event({
                                category: 'Media Link',
                                action: 'Download',
                                label: `Avatar - Mugi`
                        })}}/>
                </a>
            </div>
        </div>
    </div>
)


export default Media;